/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createProjectListIconStyles = makeStyles(theme => ({
  icon: {
    minWidth: '36px',
    minHeight: '36px',
    width: '32px',
    height: '32px',
    borderRadius: '6px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '12px',
    backgroundColor: '#D2EAFD',
  },
  textContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    fontSize: '14px',
    lineHeight: '18px',
  },
  text: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    flex: 1,
  },
  description: {
    fontWeight: 400,
  },
}));
